/**
 * The jenly.ai logo.
 *
 * The supplied artwork has a white wordmark, which disappears on a light background, so
 * two variants are generated from it (see the note in README): the original for dark mode,
 * and one with the wordmark recoloured to the logo's own deep blue for light mode. Both are
 * rendered and CSS shows whichever matches the active theme — that avoids a flash of the
 * wrong one, which swapping `src` in JavaScript would cause.
 *
 * The bird on its own is cyan throughout, so `variant="mark"` needs no such treatment.
 */
interface Props {
  /** "mark" is the bird alone, for tight spaces; "full" includes the wordmark. */
  variant?: "mark" | "full";
  height?: number;
  className?: string;
}

export function JenlyLogo({ variant = "mark", height = 32, className }: Props): JSX.Element {
  if (variant === "mark") {
    return (
      <img
        src="/jenly-mark.png"
        alt="jenly.ai"
        height={height}
        style={{ height, width: "auto" }}
        className={className}
      />
    );
  }

  return (
    <span className={className ? `jenly-logo ${className}` : "jenly-logo"} style={{ height }}>
      <img
        src="/jenly-logo-on-light.png"
        alt="jenly.ai"
        className="logo-light"
        style={{ height, width: "auto" }}
      />
      <img
        src="/jenly-logo-on-dark.png"
        alt=""
        aria-hidden="true"
        className="logo-dark"
        style={{ height, width: "auto" }}
      />
    </span>
  );
}
